const useSortList = (): { title: string; value: string }[] => {
  return [
    {
      title: 'All',
      value: 'all',
    },
    {
      title: 'Current Rewards',
      value: 'current',
    },
    {
      title: 'Past Rewards',
      value: 'past',
    },
  ];
};

export default useSortList;
